import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import NavLink from "./NavLink";
import DropdownItem from "./DropdownItem";
import styled from "styled-components";

const CssTitle = styled.span`
  color: #27bbc5;
  margin: 0 40px 0 20px;
`;

class Menu extends Component {
  render() {
    return (
      <Fragment>
        <style type="text/css">
          {`
                .bg-custom {
                    background-color: #FAFAFA !important;
                    border-top: 3px solid #27bbc5;
                    border-bottom: 1px solid #EDF1F2;
                }
                `}
        </style>

        <Navbar bg="custom" variant="light" expand="lg" sticky="top">
          <Link to="/">
            <Navbar.Brand>
              &nbsp;
              <img
                alt=""
                src="/logo-resamania-inline.png"
                height="30"
                className="d-inline-block align-top"
              />
              &nbsp;
              <CssTitle>developer();</CssTitle>
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <NavDropdown title="Cas d'utilisation" id="basic-nav-dropdown">
                <DropdownItem mode="public" to="/about/public/working-with-chains">
                  Travailler avec des chaînes de clubs
                </DropdownItem>
                <DropdownItem mode="public" to="/about/public/book-an-event">
                  Réserver un cours
                </DropdownItem>
                <DropdownItem mode="public" to="/about/public/usecase-add-and-sign-a-mandate">
                  Ajouter et signer un mandat
                </DropdownItem>
                <DropdownItem mode="public" to="/about/public/usecase-add-a-sale-to-existing-contact">
                  Vendre à un client existant
                </DropdownItem>
                <DropdownItem mode="public" to="/about/public/online-registration">
                  Inscription en ligne
                </DropdownItem>
              </NavDropdown>
              <NavLink mode="public" to="/about/public/authentication">
                Authentification
              </NavLink>
              <NavDropdown title="API Reference" id="basic-nav-dropdown">
                <DropdownItem mode="public" to="/api/product">
                  Catalogue produits
                </DropdownItem>
                <DropdownItem mode="public" to="/api/club">
                  Club
                </DropdownItem>
                <DropdownItem mode="public" to="/api/contact">
                  Contact
                </DropdownItem>
                <DropdownItem mode="public" to="/api/accounting">
                  Comptabilité
                </DropdownItem>
                <DropdownItem mode="public" to="/api/communication">
                  Communication
                </DropdownItem>
                <DropdownItem mode="public" to="/api/access-control">
                  Contrôle d'accès
                </DropdownItem>
                <DropdownItem mode="private" to="/api/export">
                  Exports
                </DropdownItem>
                <DropdownItem mode="private" to="/api/file">
                  Fichiers
                </DropdownItem>
                <DropdownItem mode="private" to="/api/feed">
                  Historique du contact
                </DropdownItem>
                <DropdownItem mode="private" to="/api/lib">
                  Librairies
                </DropdownItem>
                <DropdownItem mode="private" to="/api/media">
                  Media
                </DropdownItem>
                <DropdownItem mode="public" to="/api/oauth">
                  OAuth
                </DropdownItem>
                <DropdownItem mode="public" to="/api/partner">
                  Partner
                </DropdownItem>
                <DropdownItem mode="private" to="/api/customization">
                  Personnalisation espace membre
                </DropdownItem>
                <DropdownItem mode="public" to="/api/booking">
                  Planning et réservation
                </DropdownItem>
                <DropdownItem mode="private" to="/api/sepa">
                  Prélèvement SEPA
                </DropdownItem>
                <DropdownItem mode="private" to="/api/profile">
                  Profils de droits
                </DropdownItem>
                <DropdownItem mode="public" to="/api/referential">
                  Référentiels
                </DropdownItem>
                <DropdownItem mode="public" to="/api/club-network">
                  Réseaux de clubs
                </DropdownItem>
                <DropdownItem mode="private" to="/api/partner">
                  Resources partenaires
                </DropdownItem>
                <DropdownItem mode="private" to="/api/dashboard">
                  Tableaux de bord
                </DropdownItem>
                <DropdownItem mode="public" to="/api/sale">
                  Vente
                </DropdownItem>
                <DropdownItem mode="private" to="/api/lib">
                  Autres librairies
                </DropdownItem>
              </NavDropdown>

              {process.env.REACT_APP_DOCUMENTATION_MODE === "private" && (
                <NavDropdown
                  title="Documentation interne"
                  id="basic-nav-dropdown"
                >
                  <DropdownItem mode="private" to="/about/private/channel-aware">
                    Canal de création client
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/access-control">
                    Contrôle d'accès
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/validation-chain">
                    Chaînes de validation
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/contract-model">
                    Créer un modèle de contrat
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/command-request">
                    CommandRequest - FAQ
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/export-automation">
                    Exports automatisés - mode d'emploi
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/feed">
                    Feed
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/elastica-filter">
                    Filtre ElasticSearch
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/mandrill">
                    Intégration avec Mandrill
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/overview">
                    Livret d'accueil développeur
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/delivery">
                    Livrer une version de l'API
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/amqp-messages">
                    Messages AMQP
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/local-environment">
                    Mettre en place un environnement local et l'utiliser
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/integrations">
                    Partenaires
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/qrcode">
                    QR Code dynamique
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/attendee-group">
                    Réservation récurrente
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/smartview">
                    Smartview
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/dashboard">
                    Tableau de bord
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/translation">
                    Traduction de l'API
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/workflow">
                    Workflow
                  </DropdownItem>
                  <NavDropdown.Divider />
                  <DropdownItem mode="private" to="/about/private/how-to">
                    Maintenir la documentation
                  </DropdownItem>
                  <DropdownItem mode="private" to="/about/private/doc-to-review">
                    Documentations à revoir
                  </DropdownItem>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Fragment>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js